import React from 'react';

interface BlogFigureProps {
  children: React.ReactNode;
  id?: string;
  figureNumber?: number;
  caption?: React.ReactNode;
  className?: string;
  frameClassName?: string;
  style?: React.CSSProperties;
}

interface BlogFigureFrameProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

interface BlogFigureCaptionProps {
  children?: React.ReactNode;
  caption?: React.ReactNode;
  figureNumber?: number;
}

export function BlogFigureLabel({ number }: { number: number }) {
  return (
    <a
      href={`#figure-${number}`}
      aria-label={`Link to Figure ${number}`}
      title={`Link to Figure ${number}`}
      className="font-semibold text-foreground no-underline hover:text-brand-mint focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-mint/50"
    >
      Figure {number}.
    </a>
  );
}

export function BlogFigureFrame({
  children,
  className = 'p-2 sm:p-4',
  style,
}: BlogFigureFrameProps) {
  return (
    <div
      className={`w-full max-w-full overflow-hidden rounded-[18px] border border-border bg-background ${className}`}
      style={style}
    >
      {children}
    </div>
  );
}

export function BlogFigureCaption({
  children,
  caption,
  figureNumber,
}: BlogFigureCaptionProps) {
  if (!children && !caption) return null;

  return (
    <figcaption className="mt-4 max-w-[920px] font-mono text-[12px] leading-5 text-foreground-muted sm:text-[13px]">
      {children || (
        <>
          {figureNumber && (
            <>
              <BlogFigureLabel number={figureNumber} />{' '}
            </>
          )}
          {caption}
        </>
      )}
    </figcaption>
  );
}

export function BlogFigure({
  children,
  id,
  figureNumber,
  caption,
  className = '',
  frameClassName,
  style,
}: BlogFigureProps) {
  return (
    <figure id={id} className={`scroll-mt-28 sm:scroll-mt-32 ${className}`} style={style}>
      <BlogFigureFrame className={frameClassName}>
        {children}
      </BlogFigureFrame>
      <BlogFigureCaption caption={caption} figureNumber={figureNumber} />
    </figure>
  );
}
